import { Box } from '@mui/material';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { IConsultant, IGlobalJobSearchFilterDTO } from 'wisestep-api';
import { ScrollableTabs, WsDrawer } from 'wisestep-base';

import { hotJobsDefaultQuery } from '../../../../../features/importConsultants/helper/HotJobsDefaultQuery';
import useHotJobsListing from '../../hooks/useHotJobsListing';

import AppliedJobs from './AppliedJobs';
import ConsultantInfo from './ConsultantInfo';
import MatchingJobs from './MatchingJobs';

interface IConsultantInfoProps {
  consultantData: IConsultant;
  consultants: IConsultant[];
  matchedJobsCount: number | string;
  defaultTabNumber: number;
  openDrawer: boolean;
  setOpenDrawer: Dispatch<
    SetStateAction<{
      open: boolean;
      default: number;
    }>
  >;
}

const ConsultantInfoDrawer = ({
  consultantData,
  defaultTabNumber,
  openDrawer,
  setOpenDrawer,
}: IConsultantInfoProps) => {
  const [tabPanelPage, setTabPanelPage] = useState(0);
  const [tabNumber, setTabNumber] = useState<number>(0);
  const [query, setQuery] = useState<IGlobalJobSearchFilterDTO>({
    ...hotJobsDefaultQuery,
    search: `"${consultantData.jobTitle}"` ?? [],
  });
  const [loader, setLoader] = useState<boolean>(false);
  const [matchedJobs, pagesCount] = useHotJobsListing(query, setLoader);
  const [page, setPage] = useState<number>(0);

  const renderPage = (tabId) => {
    switch (tabId) {
      case 0:
        return <ConsultantInfo consultantData={consultantData} onClick={() => {}} />;
      case 1:
        return (
          <MatchingJobs
            selectedConsultant={consultantData}
            matchedJobs={matchedJobs}
            getMatchedJobs={getMatchedJobs}
            pagesCount={pagesCount}
            loader={loader}
            tabNumber={tabNumber}
            pageChange={pageChange}
            page={page}
          />
        );
      case 2:
        return <AppliedJobs />;
    }
  };

  useEffect(() => setTabPanelPage(defaultTabNumber), [defaultTabNumber]);

  const getMatchedJobs = (tabNumber: number) => {
    setTabNumber(tabNumber);
    let source: string[] | undefined = undefined;
    switch (tabNumber) {
      case 0:
        source = undefined;
        break;
      case 1:
        source = ['email', 'email1'];
        break;
      case 2:
        source = ['TECHFETCHSEARCH', 'DICESEARCH'];
        break;
    }
    setQuery((prev) => ({
      ...prev,
      sourcesOfJob: source,
    }));
  };

  const pageChange = (value: number) => {
    setPage(value);
    setQuery((prev) => ({ ...prev, page: value }));
  };

  return (
    <WsDrawer
      open={openDrawer}
      onClose={() => setOpenDrawer({ open: false, default: 0 })}
      title={consultantData.name}
      iconType="cross"
      position="right"
      size="large"
    >
      <ScrollableTabs
        scrollList={[
          { tabName: 'Consultant Info' },
          { tabName: 'Matched Jobs' },
          { tabName: 'Applied Jobs' },
        ]}
        getTabIndex={(index: number) => setTabPanelPage(index)}
        defaultValue={defaultTabNumber}
      />

      <Box mt={1}>{renderPage(tabPanelPage)}</Box>
    </WsDrawer>
  );
};

export default ConsultantInfoDrawer;
